module.exports = __webpack_public_path__ + "static/media/W17-0688_AW-Spicy-Mama_LTO_mobile_hero_ont_man_fr.92ceb1b6.jpg";